import React from "react";
import { useState, useEffect } from "react";

import downloadIcon from "../../../../assets/download_icon.svg"
import eyeIcon from "../../../../assets/eye_icon.svg"
import replyIcon from "../../../../assets/reply_icon.svg"
import resultimg from "../../../../assets/result_img.png"
import userPic from "../../../../assets/imgby_artist1.png"
import { Header } from "../../../../components/header/Header";
import { CommentCheck } from "../../../../components/comment/CommentCheck";
import { SketchDetails } from "../../../../components/sketch_details/SketchDetails";
import img1 from "../../../../assets/imgby_artist1.png";
import img2 from "../../../../assets/imgby_artist2.png";


export const SketchComments = () => {

    const [sketchData, setSketchData] = useState({
        name: "",
        description: "",
        image1: null,
        image2: null,
    });

    useEffect(() => {
        setSketchData({
            name: "Character Designer",
            description: "This is a sample description.",
            image1: img1,
            image2: img2,
        });
    }, []);

    const users = [
        {
            name: "Lila Carter",
            title: "Character designer",
            profilePic: userPic,
        },
    ];

    return (
        <>
            <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
                {/* Header */}
                <Header
                    title={"Contest"}
                    showBack={true}
                />
            </header>
            <div className="w-full bg-[#F7F7F7] min-h-screen">
                <div className="w-full min-h-screen max-w-[1164px] mx-auto flex flex-col items-start justify-center gap-10 lg:flex-row mt-9">
                    {/* Left Side */}
                    <div className='w-full lg:max-w-[446px] flex  flex-col '>
                        <SketchDetails
                            name={sketchData.name}
                            description={sketchData.description}
                            image1={sketchData.image1}
                            image2={sketchData.image2}
             sketchData={sketchData}
            


                        />
                        <hr className="mt-5 mb-5" />
                        <div className="flex flex-col gap-2 p-2">
                            <h2 className="font-bold font-grotesk text-sm  text-black">Artist Name</h2>
                            <div className="w-full flex">
                                <div className="flex flex-col gap-4">
                                    {users.map((user) => (
                                        <div key={user.id} className="flex items-center gap-2">
                                            {/* Profile Pic */}
                                            <div className="w-[69px] h-[69px] border-2 border-secondary rounded-full p-[1px] flex items-center justify-center">
                                                <div className=" w-[57px] h-[57px]  rounded-full overflow-hidden">
                                                    <img
                                                        src={user.profilePic}
                                                        alt="Profile"
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                            {/* User Info */}
                                            <div>
                                                <p className="text-[16px] text-black font-bold font-grotesk">
                                                    {user.name}
                                                </p>
                                                <p className="text-sm text-[#1F1F1F] font-medium font-grotesk">
                                                    {user.title}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Right Side */}
                    <div className="w-full lg:max-w-[666px] sm:min-w-[440px]  flex flex-col gap-5">
                        <div className="w-full h-[377px]  flex flex-col items-start  rounded-[14px] overflow-hidden relative">
                            <img src={resultimg} alt="" className="w-full h-full object-cover" />
                            <div className="absolute bottom-4 right-4 flex items-center gap-2">
                                <button className="bg-secondary h-9 p-[10px] rounded-lg"><img src={downloadIcon} alt="Download" /></button>
                                <button className="bg-secondary h-9 p-[10px] rounded-lg"><img src={eyeIcon} alt="Icon" /></button>
                            </div>
                        </div>
                        {/* Comments Section */}
                        <CommentCheck />
                    </div>
                </div>
            </div>
        </>
    )
}
